/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { MileageItinerariesResponse } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class ApiMileageItinerariesController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-mileage-itineraries-controller
   * @name FindLastItineraries
   * @request GET:/api/v1/reimbursement/mileage/itineraries
   */
  findLastItineraries = (params: RequestParams = {}) =>
    this.http.request<MileageItinerariesResponse, any>({
      path: `/v1/reimbursement/mileage/itineraries`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findLastItinerariesPath = '/v1/reimbursement/mileage/itineraries'
  static findLastItinerariesMethod = 'GET'
}
